export { getMiddlewareEndpoint } from "./api";

export const hyphenateLink = (name) => {
  return name.split(" ").join("-").toLowerCase();
};

export const validate = (values) => {
  let errors = {};

  if (!values.name) {
    errors["name"] = "Enter the name";
  } else if (values.name.length < 3) {
    errors["name"] = "Name must be at least 3 characters long";
  }

  if (!values.groupName) {
    errors["groupName"] = "Enter the group name";
  }

  if (!values.description) {
    errors["description"] = "Enter the description";
  } else if (values.description.length < 10) {
    errors["description"] = "Description must be at least 10 characters long";
  }

  return errors;
};

export const getUniqueId = () => {
  return "id-" + Math.random().toString(36).substr(2, 9);
};

export const convertTimeToMinutes = (time) => {
  let hours = Math.floor(time);
  let fractionalPart = time - hours;

  let minutes = fractionalPart * 60;

  // Total minutes
  let totalMinutes = hours * 60 + minutes;

  return totalMinutes;
};

// getMiddlewareEndpoint is re-exported from ./api
